__turbopack_context__.v({
  "backToTemplateCta": "BackToGalleryButton-module-scss-module__zn--ZW__backToTemplateCta",
});
